var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.71875,
    y: 0.453125,
    width: 61.2038,
    height: 61.2038,
    rx: 10.2006,
    fill: "#0B60D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2757 29.3527C37.2757 26.0664 34.6117 23.4023 31.3254 23.4023C28.0391 23.4023 25.375 26.0664 25.375 29.3527C25.375 32.639 28.0391 35.3031 31.3254 35.3031C34.6117 35.3031 37.2757 32.639 37.2757 29.3527Z",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2383 29.9483C37.7857 30.1142 38.3663 30.2035 38.9678 30.2035C42.2541 30.2035 44.9182 27.5394 44.9182 24.2531C44.9182 20.9668 42.2541 18.3027 38.9678 18.3027C35.8823 18.3027 33.3452 20.6513 33.0469 23.6583",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5979 23.6583C29.2995 20.6513 26.7625 18.3027 23.6769 18.3027C20.3906 18.3027 17.7266 20.9668 17.7266 24.2531C17.7266 27.5394 20.3906 30.2035 23.6769 30.2035C24.2784 30.2035 24.8591 30.1142 25.4064 29.9483",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3349 38.7017C48.3349 34.007 44.1486 30.2012 38.9844 30.2012",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6699 43.8052C40.6699 39.1105 36.4836 35.3047 31.3193 35.3047C26.1551 35.3047 21.9688 39.1105 21.9688 43.8052",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6709 30.2012C18.5067 30.2012 14.3203 34.007 14.3203 38.7017",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.7df71bf97e998e4db7f868a17d5a79e0.svg";
export { ForwardRef as ReactComponent };